const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const createDraftJob = async (formData) => {
  const res = await fetch(`${API_BASE}/drafts/create`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    body: formData
  });

  if (!res.ok) throw new Error("");
  return res.json();
};

export const fetchJobStatus = async (jobId) => {
  const res = await fetch(`${API_BASE}/drafts/job-status/${jobId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });

  if (!res.ok) throw new Error("Failed to fetch job status");
  return res.json();
};

export const downloadFile = (path) => {
  window.open(
    `${API_BASE}/drafts/download?path=${encodeURIComponent(path)}`,
    "_blank"
  );
};

/* ================= FETCH DOCUMENT SECTIONS ================= */
export const fetchDocumentSections = async () => {
  const res = await fetch(`${API_BASE}/common/document-sections`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (!res.ok) {
    const text = await res.text();
    console.error("SECTION API ERROR:", res.status, text);
	throw new Error("Failed to fetch document sections");
  }

  return res.json();
};
